import { render, staticRenderFns } from "./DosyadakiAvansinIadesiTalepEvrakForm.vue?vue&type=template&id=4b4b48ab"
import script from "./DosyadakiAvansinIadesiTalepEvrakForm.vue?vue&type=script&lang=ts"
export * from "./DosyadakiAvansinIadesiTalepEvrakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports